import React, { useRef } from 'react';
import { ResultModal } from './v2/ResultModal.styles';
import QuotationCard from '../../../reusable/QuotationCard';
import RiskCard from '../Cards/RiskCard';

// match: show quote only when processingQuote.company_id matches quote.company_id and is in this list
// always: show quote regardless of processingQuote.company_id
// showAll: skip company filtering entirely (show all quotes for this type)
// requiresCompanyId: only render this section when processingQuote.company_id equals this value
const RISK_CARD_CONFIG = {
  assistenza_stradale: { match: [1, 17, 9, 18], always: [16, 8] },
  tutela_legale: { showAll: true },
  rc_transportati_minori: { showAll: true, requiresCompanyId: 9 },
  infortuni_conducente: { match: [1, 17, 9, 18], always: [16, 8] },
  furto_incendio: { match: [18], always: [] },
};

// Company 16 (Genial Piu) quotes are only shown when the main quote is also company 16
function isCompanyAllowed(quote, processingQuote) {
  if (quote.company_id === 18 && processingQuote?.company_id !== 18) return false;
  return true;
}

function isRiskQuoteVisible(quote, processingQuote, config) {
  if (!isCompanyAllowed(quote, processingQuote)) return false;
  if (config.showAll) return true;
  const { match, always } = config;
  return always.includes(quote.company_id)
    || (match.includes(processingQuote.company_id) && quote.company_id === processingQuote.company_id);
}

function ModalQuotesMoto({
  selectQuotation, type, addingQuote, requestInfo, quotations, guaranteesPrima, refresh, processingQuote, riskQuotes,
}) {
  const closeButtonRef = useRef(null);

  const closeButton = () => {
    if (closeButtonRef.current) {
      closeButtonRef.current.click();
    }
  };

  const selectQuote = (quoteId) => selectQuotation(quoteId, closeButton);

  const typeQuotes = quotations?.[type.id];
  const config = RISK_CARD_CONFIG[type.id];

  const renderRiskCard = (quote, index) => (
    <div className="col-12 mb-2" key={index}>
      <RiskCard
        quote={quote}
        type={type}
        selectQuotation={selectQuote}
        requestInfo={requestInfo}
        riskQuotes={riskQuotes}
      />
    </div>
  );

  const canShowRiskSection = config
    && quotations
    && typeQuotes
    && (!config.requiresCompanyId || processingQuote?.company_id === config.requiresCompanyId);

  return (
    <ResultModal
      className="modal fade"
      id={type.id}
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              {type.name}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="buttonClose"
              ref={closeButtonRef}
            />
          </div>
          <div className="modal-body">
            {addingQuote && (
              <div className="d-flex align-items-center justify-content-between flex-column">
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Aggiungendo...</span>
                  </div>
                </div>
                <div className="ms-2">Aggiungendo...</div>
              </div>
            )}
            {addingQuote === false && (
              <div className="row purchase-quote-eight-step">
                {/* res_civile */}
                {type.id === 'res_civile' && quotations && typeQuotes && typeQuotes.map((quote, index) => (
                  <React.Fragment key={index}>
                    {((quote.company_id === null && quote.added_manually === 1)
                      || (quote.company_id !== null && quote.added_manually == 0)) && (
                        <div className="col-12 mb-2">
                          <QuotationCard
                            quote={quote}
                            selectQuotation={selectQuote}
                            requestInfo={requestInfo}
                            guaranteesPrima={guaranteesPrima}
                            refresh={refresh}
                          />
                        </div>
                    )}
                    {quote.product_id === 10 && (
                      <div className="col-12 mb-2">
                        <QuotationCard
                          quote={quote}
                          selectQuotation={selectQuote}
                          requestInfo={requestInfo}
                        />
                      </div>
                    )}
                  </React.Fragment>
                ))}

                {/* Risk card types filtered by per-type company ID config */}
                {canShowRiskSection && (
                  config.showAll || processingQuote !== null ? (
                    typeQuotes
                      .filter((q) => isRiskQuoteVisible(q, processingQuote, config))
                      .map((q, i) => renderRiskCard(q, i))
                  ) : (
                    <h5 className="fw-bold">Nessuna Quotazione Trovata</h5>
                  )
                )}

                {quotations && typeQuotes && typeQuotes.length === 0 && (
                  <h5 className="fw-bold">Nessuna Quotazione Trovata</h5>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger px-4"
              data-bs-dismiss="modal"
            >
              Chiudi
            </button>
          </div>
        </div>
      </div>
    </ResultModal>
  );
}

export default ModalQuotesMoto;
